import {filter, lazy} from './lang.js';
import {uuid} from 'uuidv4';

export const append = (list, x) => {
    return (... args) => {
        let _list = lazy(list, ...args);
        let _x = lazy(x, ...args);
        _list.push(_x);
        return filter(true);
    };
};

export const sublist = (list, a,b) => {
    return (... args) => {
        let _list = lazy(list, ...args);
        if (_list) {
            let _a = lazy(a, ...args);
            let _b = undefined;
            if (b) {
                _b = lazy(b, ...args);
            }
            return _list.slice(_a, Math.max(1, _b % (_list.length + 1)));
        }
        return 0;
    };
};

export const vectorAdd = (...vecs) =>
    (... args) => {
        let _vecs = vecs;
        if (vecs.length === 1) {
            if (Array.isArray(vecs[0])) {
                _vecs = vecs[0];
            } else {
                _vecs = lazy(vecs[0], ...args);
            }
        }
        return _vecs.reduce(
            (acc, current) =>
                lazy(current, ...args).map(
                    (x,i) => x + acc[i % acc.length]),
            [0]);
    };

export const len = (list) => {
    return (... args) => {
        let _list = lazy(list, ...args);
        if (_list) {
            return _list.length;
        }
        return 0;
    };
};
export const map = (list, fn) => {
    return (... args) => {
        let _list = lazy(list, ...args);
        let _fn = fn;
        return _list.map(_fn);
    };
};

export const nth = (n, list) => {
    return (... args) => {
        if (!args[0]) {
            return list[0];
        }
        let _list = lazy(list, ...args);
        let _n = lazy(n, ...args);
        return _list[_n % _list.length];
    };
};

export const cdr = (list) => {
    return (... args) => {
        let _list = lazy(list, ...args);
        if (_list) {
            return _list.slice(1);
        } else {
            return [];
        }
    };
};

export const car = (list) => {
    return (... args) => {
        let _list = lazy(list, ...args);
        if (_list) {
            return _list[0];
        } 
    };
};


export const lconcat = (lists) => {
    let lazyValue = undefined;
    let lastList = undefined;
    return (...args) => {
        let _lists = lazy(lists, ...args);
        if (_lists === lastList) {
            return lazyValue;
        }

        let list = [];
        for (let l of _lists) {
            l = lazy(l, ...args);
            if (Array.isArray(l)) {
                list = [... list, ...l];
            } else if (l) {
                if (l.id) {
                    l.id = uuid();
                }
                list = [... list, l];
            }
        }

        lazyValue = list;
        lastList = _lists;
        return list;
    };
};

export const concat = (...lists) => {
    let lastLists = undefined;
    let lazyValue = undefined;
    return (...args) => {
        let list = [];
        if (lastLists === lists) {
            // todo: is this right?
            return lazyValue;
        } 
        lastLists = lists;
        for (let l of lists) {
            l = lazy(l, ...args);
            if (Array.isArray(l)) {
                list = [... list, ...l];
            } else {
                if (l.id) {
                    l.id = uuid();
                }
                list = [... list, l];
            }
        }
        lazyValue = list;
        return lazyValue;
    };
};

export const rconcat = (...lists) => {
    let lastLists = undefined;
    let lazyValue = undefined;
    return (...args) => {
        let _lists = lists.map(x => lazy(x, ...args));
        if (lastLists && lastLists.every((x,i) =>  x === _lists[i])) {
            // todo: is this right?
            return lazyValue;
        } 
        lastLists = _lists;
        let list = [];
        for (let l of _lists) {
            if (Array.isArray(l)) {
                list = [... list, ...l];
            } else if (l) {
                if (l.id) {
                    l.id = uuid();
                }
                list = [... list, l];
            }
        }
        lazyValue = list;
        return lazyValue;
    };
};

export const t_reverse = (list) => {
    return (...args) => {
        let _list = lazy(list, ...args);
        _list = [... _list[0]];
        _list.reverse();
        return [_list];
    };
};

// creates a list out of arg
export const list = (...lists) => {
    return (...args) => {
        let list = [];
        for (let l of lists) {
            l = lazy(l, ...args);
            if (l.id) {
                l.id = uuid();
            }
            list = [... list, l];
        }
        return list;
    };
};


export const t_sublist = (list, a,b) => {
    return (... args) => {
        let _list = lazy(list, ...args);
        if (_list) {
            let _a = lazy(a, ...args);
            let _b = undefined;
            if (b) {
                _b = lazy(b, ...args);
            }
            return [_list[0].slice(_a, Math.max(1, _b % (_list[0].length + 1)))];
        }
        return 0;
    };
};


export const altList = (list, alternate=2, off=0) => {
    return (...args) => {
        let _list = lazy(list, ...args);
        let _alternate = lazy(alternate, ...args);
        let _off = lazy(off, ...args);

        let ret = [_list[0]];
        for (let i=1; i < _list.length; i++ ){
            if (i%alternate===_off) {
                ret.push(_list[i]);
            }
        }
        return ret;
    };
};
